import { render, staticRenderFns } from "./DashboardDefault.vue?vue&type=template&id=7d61d48a&lang=pug"
import script from "./DashboardDefault.vue?vue&type=script&lang=js"
export * from "./DashboardDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports